import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import termosTexto from '../assets/termos.txt';
import '../styles/termos-page.css';

const TermosDeUso = () => {
  const [conteudoTermos, setConteudoTermos] = useState('');
  const [carregando, setCarregando] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Carregar o arquivo de termos
    fetch(termosTexto)
      .then(response => response.text())
      .then(text => {
        setConteudoTermos(text);
        setCarregando(false);
      })
      .catch(err => {
        console.error('Erro ao carregar termos:', err);
        setCarregando(false);
      });
  }, []);

  // Função para formatar o conteúdo
  const formatarConteudo = (texto) => {
    return texto.split('\n').map((linha, index) => {
      // Detectar títulos (MAIÚSCULAS)
      if (linha.trim() && linha === linha.toUpperCase() && linha.length > 10) {
        return (
          <h4 key={index} className="termo-titulo mt-4 mb-3">
            {linha}
          </h4>
        );
      }
      
      // Detectar subtítulos (começam com números como "1.", "1.1.", "38.1.")
      if (/^\d+\./.test(linha.trim())) {
        return (
          <p key={index} className="termo-item mb-3">
            <strong>{linha}</strong>
          </p>
        );
      }
      
      // Detectar itens de lista (começam com *)
      if (linha.trim().startsWith('*')) {
        return (
          <li key={index} className="termo-lista-item mb-2">
            {linha.replace('*', '').trim()}
          </li>
        );
      }
      
      // Linhas vazias
      if (!linha.trim()) {
        return <div key={index} className="termo-espaco" style={{height: '10px'}}></div>;
      }
      
      // Texto normal
      return (
        <p key={index} className="termo-paragrafo mb-2">
          {linha}
        </p>
      );
    });
  };

  return (
    <div className="termos-page-container">
      <div className="container-fluid mt-4">
        {/* Conteúdo dos Termos */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-5">
                {carregando ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-warning" style={{width: '3rem', height: '3rem'}}>
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <p className="mt-3 text-muted">Carregando termos de uso...</p>
                  </div>
                ) : (
                  <>
                    {/* Título Principal */}
                    <div className="text-center mb-5">
                      <h2 className="termo-titulo-principal mb-3">
                        <i className="fas fa-file-contract me-2 text-warning"></i>
                        Termos de Uso e Política de Privacidade
                      </h2>
                      <p className="text-muted">
                        <i className="fas fa-calendar-alt me-2"></i>
                        Última atualização: {new Date().toLocaleDateString('pt-BR')}
                      </p>
                    </div>

                    {/* Aviso Importante */}
                    <div className="alert alert-info border-start border-4 mb-4" style={{borderColor: '#f39c12'}}>
                      <h5 className="alert-heading">
                        <i className="fas fa-info-circle me-2"></i>
                        Informação Importante
                      </h5>
                      <p className="mb-0">
                        Ao utilizar nossa plataforma, você concorda com os termos e condições descritos abaixo. 
                        Recomendamos a leitura atenta de todo o documento.
                      </p>
                    </div>

                    {/* Conteúdo dos Termos Formatado */}
                    <div className="termos-content-formatado">
                      {formatarConteudo(conteudoTermos)}
                    </div>

                    {/* Rodapé com Selos */}
                    <hr className="my-5" />
                    
                    <div className="row align-items-center">
                      <div className="col-md-8">
                        <h5 className="mb-3">
                          <i className="fas fa-certificate me-2 text-success"></i>
                          Certificações e Conformidade
                        </h5>
                        <p className="text-muted mb-0">
                          Nossa plataforma está em conformidade com a Lei Geral de Proteção de Dados (LGPD) 
                          e possui cobertura de Responsabilidade Civil para garantir a segurança e 
                          privacidade dos seus dados.
                        </p>
                      </div>
                      <div className="col-md-4 text-end">
                        <span className="badge bg-success me-2 p-2">
                          <i className="fas fa-shield-alt me-1"></i>
                          LGPD Compliance
                        </span>
                        <span className="badge bg-primary p-2">
                          <i className="fas fa-certificate me-1"></i>
                          RC Certificado
                        </span>
                      </div>
                    </div>

                    {/* Botão Voltar */}
                    <div className="text-center mt-5">
                      <button 
                        className="btn btn-lg"
                        style={{
                          backgroundColor: '#f39c12',
                          borderColor: '#f39c12',
                          color: '#fff',
                          minWidth: '200px'
                        }}
                        onClick={() => navigate(-1)}
                      >
                        <i className="fas fa-arrow-left me-2"></i>
                        Voltar ao Dashboard
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Rodapé da Página */}
        <div className="row mt-4 mb-3">
          <div className="col-12">
            <div className="card border-0 bg-light">
              <div className="card-body">
                <div className="row text-center">
                  <div className="col-md-4">
                    <small className="text-muted">
                      <i className="fas fa-lock me-1 text-success"></i>
                      <strong>Seus dados estão protegidos</strong>
                    </small>
                  </div>
                  <div className="col-md-4">
                    <small className="text-muted">
                      <i className="fas fa-file-contract me-1 text-warning"></i>
                      <strong>Termos transparentes</strong>
                    </small>
                  </div>
                  <div className="col-md-4">
                    <small className="text-muted">
                      <i className="fas fa-headset me-1 text-info"></i>
                      <strong>Suporte disponível</strong>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermosDeUso;